module.exports = __webpack_public_path__ + "bb3017030eac8c044cb2ac3b957d0a68.png";